export type PortalOverlayOwner = 'navigation' | 'stars';

const PORTAL_OVERLAY_EVENT = 'airbotix:portal-overlay-open';

export function openPortalOverlay(owner: PortalOverlayOwner): void {
  window.dispatchEvent(new CustomEvent<PortalOverlayOwner>(PORTAL_OVERLAY_EVENT, { detail: owner }));
}

export function closeWhenAnotherPortalOverlayOpens(
  owner: PortalOverlayOwner,
  close: () => void,
): () => void {
  const listener = (event: Event) => {
    if ((event as CustomEvent<PortalOverlayOwner>).detail !== owner) close();
  };
  window.addEventListener(PORTAL_OVERLAY_EVENT, listener);
  return () => window.removeEventListener(PORTAL_OVERLAY_EVENT, listener);
}
